import tablelistApi from 'api/tablelistApi'

export default {
  list(options = {}) {
    return tablelistApi.get('/membership-plan', options)
  },
}



// WEBPACK FOOTER //
// ./src/api/membershipPlan/service.js